export interface IRemoteUpdateClassWrapper {
    connectedCount: number;
    equipmentsList: assetList[];
    idleCount: number;
    latestSoftwareVersion: string;
    notConnectedCount: number;
    offStatusFacilityList?: facilityList[];
    onStatusFacilityList?: facilityList[];
    releaseDate: Date;
    hasSoftwareRelease?: string;
    softwareSize: number;
}

export interface assetList {
    activityId: number;
    softwareUpdateAssetList: updateList[];

    // for select
    selected?: boolean;
    disabled?: boolean;
}

export interface updateList {
    assetId: string;
    assetName: string;
    bodySerial: string;
    connected: string;
    facilityName: string;
    idle: string;
    lastAttemptDate: Date;
    modelId: number;
    pending: string;
    scheduledDate: Date;

    // for select
    selected?: boolean;
}

export interface facilityList {
    facilityId: number;
    facilityName: string;
}

export interface ILifescapeUpdateClassWrapper {
    isGatewayStatus?: boolean;
    gatewayLifescapeCourseUpdateStatus?: string;
    lifescapeCourseUpdateEquipmentList: equipmentList[];
    lifescapeStatusOFFFacilityList?: facilityList[];
    lifescapeStatusONFacilityList?: facilityList[];
}

export class equipmentList {
    activityId: number;
    lifescapeCourseUpdateAssetsList: lifescapeAssetList[];
    lifescapeCourses: courseList[];
}

export class lifescapeAssetList {
    activityId: number;
    assetDisplayName: string;
    assetId: string;
    bodySerial: string;
    facilityName: string;
    isOnline?: string;
    lifescapeCourseUpdateStatus?: string;
}

export class courseList {
    effectiveDate: Date;
    id: string;
    name: string;
    targets: string;
    version: number;
}

export interface ILifescapeCourseClassWrapper {
    latestLifescapeCourseInfo: courseObject;
    lifescapeCoursesInfoList: courseObject[];
}

export class courseObject {
    bikeNonTreadCourses: string;
    ellipticalNonTreadCourses: string;
    lifescapeTreadCourses: string;
    nonTreadSize: number;
    nonTreadURL: URL;
    powermillNonTreadCourses: string;
    releaseDateTimeStamp: Date;
    treadSize: number;
    treadURL: URL;
}


export interface IDownloadSoftwareResponse {
    donotShowSoftwarePop: string;
    softwareDownloadVO: ISoftwareDownloadVO[];
}

export interface ISoftwareDownloadVO {
    consoleId: string;
    consoleType: string;
    latestSoftwareVersion: string;
    releaseDate: string;
    softwareSize: string;
    hasSoftwareRelease: string;
    url: URL;
}